import { render } from "./Footer.vue?vue&type=template&id=629ca9d4&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=629ca9d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-629ca9d4"

export default script